import { useLang } from '@/i18n';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTab from '@elem/ui/ef-tab';
import { FC, useMemo, useState } from 'react';
import css from './index.module.scss';

const TheComp: FC = () => {
    const { t } = useLang('delta3Plus.AU5');
    const { pageStatus } = useDP3Store();

    const items = [
        {
            title: t('tab1'),
            type: '1',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737427086302/AC.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737427086110/AC%20charging.jpg',
        },
        {
            title: t('tab2'),
            type: '2',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736749404845/SC.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736841127398/Solar%20charging.jpg',
        },
        {
            title: t('tab3'),
            type: '3',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736749405389/Car%20Charging.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1736841122484/Car%20charging.jpg',
        },
        {
            title: t('tab4'),
            type: '4',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737427229109/Generator%20charging.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737427228924/Generator%20charging%20M.jpg',
        },
    ];
    const [active, setActive] = useState(items[0].type);
    const current = useMemo(() => items.find((item) => item.type === active), [active]);

    return (
        <div className={`${css.thecomp}`} id="AU_5">
            <EfSpec />
            <img className="au4-icon" src="https://websiteoss.ecoflow.com/upload/image/1736733785936/au4-icon.svg" alt="" />
            <EfSection title={t('title')} desc={t('desc')} />
            <EfImg pc={current?.pc ?? ''} h5={current?.h5} />
            <div className="tab-container">
                <EfTab
                    items={items}
                    activeType={active}
                    onChange={(item) => {
                        setActive(item.type);
                    }}
                />
            </div>
            <EfSpec />
        </div>
    );
};

export default TheComp;
